import { useResolvedContentParametersCatalogQuery } from 'data/generated/graphql';
import { useConvertedProperty } from 'hooks/useConvertedProperty';

const useContentParametersCatalog = () => {
  const publicationKey = useConvertedProperty();

  return useResolvedContentParametersCatalogQuery(
    { publicationKey: publicationKey ?? '' },
    {
      enabled: !!publicationKey,
      staleTime: 60000,
    }
  );
};

export default useContentParametersCatalog;
